<template>
  <div v-if="email" class="email-ticket" :class="{ 'email-ticket-invalid': !valid }">
    <span class="email-ticket-text text">{{ email }}</span>
    <DeleteIcon class="email-ticket-delete-btn" @click="$emit('remove-email')" />
  </div>
</template>

<script>
  import DeleteIcon from '@/assets/icons/x.svg';

  export default {
    name: 'EmailTicket',
    components: {
      DeleteIcon,
    },
    props: {
      email: {
        type: String,
        required: true,
      },
      valid: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>
